<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('pending requests')"
      :columns="columns"
      :column_search="true"
      resource_url="/credit-analysis/request/pending-datatables"
    >
    </generic-table>

    <!-- Create/Edit Modal -->
    <credit-analysis-evaluation-modal
      ref="modal"
      @saved="onSaved"
      @deny_request="onDenyRequest"
    />

    <!-- Detail Modal -->
    <credit-analysis-evaluation-detail-modal ref="detail_modal" />
    <credit-analysis-request-detail-modal ref="request_detail_modal" />
  </div>
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import CreditAnalysisEvaluationModal from "./credit_analysis_evaluation_modal/Index.vue";
import CreditAnalysisEvaluationDetailModal from "./credit_analysis_evaluation_detail_modal/Index.vue";
import CreditAnalysisRequestDetailModal from "../credit_analysis_requests_datatable/credit_analysis_request_detail_modal/Index.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  success_message,
  format_currency,
  error_message,
} from "@/utils";
import moment from "moment";

export default {
  name: "CreditAnalysisEvaluationsDatatable",
  components: {
    GenericTable,
    CreditAnalysisEvaluationModal,
    CreditAnalysisEvaluationDetailModal,
    CreditAnalysisRequestDetailModal,
  },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: this.$t("customer"),
          searchable: false,
          // width: "20%",
          data: (row) => {
            return `<div class="title is-5">${row.customer_name || ""}</div>
                    <div class="subtitle is-6 mb-1">
                      <span class="icon">
                        <i class="fa fa-id-card"></i>
                      </span>
                      <span>
                        <strong>${v.$t("dpi")}: </strong> ${row.dpi || ""}
                      </span>
                    </div>
                    <div class="subtitle is-6">
                      <span class="icon">
                        <i class="fa fa-tags"></i>
                      </span>
                      <span>
                        <strong>${v.$t("segment")}: </strong> ${v.$t(
              row.settings?.segment || "unset"
            )}
                      </span>
                    </div>`;
          },
        },
        {
          title: this.$t("other info"),
          searchable: false,
          // width: "15%",
          data: (row) => {
            let call_id = "";
            if (row.settings && row.settings.call_id) {
              call_id = `<div class="subtitle is-6 mb-0"><span class="icon"><i class="fa fa-phone"></i></span><span>
                <strong>${v.$t("call id")}: </strong> ${row.settings.call_id}
              </span></div>`;
            }

            let income = "";
            if (row.settings && row.settings.income) {
              income = `<div class="subtitle is-6"><span class="icon"><i class="fa fa-money"></i></span><span>
                <strong>${v.$t("income")}: </strong> ${format_currency(
                row.settings.income
              )}
              </span></div>`;
            }
            return `<div class="subtitle is-6 mb-0"><span class="icon"><i class="fa fa-file-text"></i></span><span>
              <strong>${v.$t("pagare")}: </strong> ${row.pagare_number || ""}
            </span></div>
            <div class="subtitle is-6 mb-0"><span class="icon"><i class="fa fa-id-card"></i></span><span>
              <strong>${v.$t("nit")}: </strong> ${row.nit || ""}
            </span></div>${call_id}${income}`;
          },
        },
        {
          title: this.$t("assigned user"),
          searchable: false,
          // width: "15%",
          data: (row) => row.assigned_user?.username || v.$t("not set"),
        },
        {
          title: this.$t("status"),
          name: "status",
          searchable: false,
          // width: "10%",
          data: (row) => {
            const statusClass = this.getStatusClass(row.status);
            return `<span class="tag ${statusClass}">${this.$t(
              row.status || "draft"
            )}</span>`;
          },
        },
        {
          title: this.$t("request date"),
          name: "create_date",
          searchable: false,
          // width: "12%",
          data: (row) => {
            return `<div class="title is-6">${row.create_user?.username}</div>
            <div class="subtitle is-6">${moment(row.create_date).format(
              "DD/MM/YYYY HH:mm"
            )}</div>`;
          },
        },
        {
          title: this.$t("actions"),
          width: "15%",
          data: (row) => {
            let v = this;
            let btns = [
              // {
              //   args: { uuid: row.uuid },
              //   tooltip: v.$t("view"),
              //   icon: "fa fa-eye",
              //   icon_class: "is-small has-text-info",
              //   click: (e) => {
              //     v.$refs.request_detail_modal.open(row.uuid);
              //   },
              // },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("evaluate"),
                icon: "fa fa-bolt",
                icon_class: "is-small has-text-warning",
                click: (e) => {
                  v.$emit("evaluate", row.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete credit analysis request?"),
                    v,
                    () => {
                      del("/credit-analysis/request", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
              //   {
              //     args: { uuid: row.uuid },
              //     tooltip: v.$t("edit"),
              //     icon: "fa fa-edit",
              //     icon_class: "is-small has-text-warning",
              //     click: (e) => {
              //       v.$refs.modal.open(row.uuid);
              //     },
              //   },
            ];

            return generate_datatables_buttons(btns);
          },
          // generate_datatables_buttons(
          //   row,
          //   this.edit,
          //   this.delete,
          //   this.view,
          //   [
          //     {
          //       title: this.$t("upload pdf"),
          //       icon: "fa fa-upload",
          //       class: "is-warning",
          //       action: this.uploadPdf,
          //       condition: !row.pdf_file_path,
          //     },
          //     {
          //       title: this.$t("complete evaluation"),
          //       icon: "fa fa-check-circle",
          //       class: "is-success",
          //       action: this.completeEvaluation,
          //       condition: row.status === "draft",
          //     },
          //   ]
          // ),
        },
      ],
    };
  },
  methods: {
    create() {
      // Check if there's a request_uuid in route query
      const request_uuid = this.$route.query.request_uuid;
      this.$refs.modal.open(null, request_uuid);
    },
    edit(row) {
      this.$refs.modal.open(row.uuid);
    },
    view(row) {
      this.$refs.detail_modal.open(row.uuid);
    },
    delete(row) {
      confirm_deletion_dialog(() => {
        del("/credit-analysis/evaluation", { uuid: row.uuid })
          .then(() => {
            success_message(this.$t("evaluation deleted successfully"));
            this.refresh();
          })
          .catch((error) => {
            error_message(error);
          });
      });
    },
    uploadPdf(row) {
      this.$refs.modal.open(row.uuid, null, "upload");
    },
    completeEvaluation(row) {
      // Quick complete evaluation
      this.$refs.modal.open(row.uuid, null, "complete");
    },
    refresh() {
      this.$refs.datatable.refresh();
    },
    onSaved() {
      this.refresh();
    },
    exportResults() {
      const url = "/credit-analysis/evaluation/export?format=csv";
      window.open(url, "_blank");
      success_message(this.$t("export started"));
    },
    getResultClass(result) {
      const classes = {
        approved: "is-success",
        rejected: "is-danger",
        pending_review: "is-warning",
      };
      return classes[result] || "is-dark";
    },
    getStatusClass(status) {
      const classes = {
        draft: "is-dark",
        completed: "is-success",
        archived: "is-dark",
      };
      return classes[status] || "is-dark";
    },
    onDenyRequest(request_uuid) {
      console.log("Deny request: [pendingrequests]", request_uuid);
      this.$emit("deny_request", request_uuid);
    },
  },
  created() {},
  mounted() {
    this.refresh();
  },
};
</script>

<style scoped>
/* Specific styles for evaluations datatable */
</style>
